import {translate} from '../../../shared/mixins/translation';
import UserView from './UserView.js';

export default class UserTableView {
    constructor(json) {
        this.id = json.id;
        this.email = json.email;
        this.accountType = json.accountType;
        this.roles = json.roles;
        this.account = json.account;
        this.name = `${json.firstName} ${json.lastName}`;
        this.active = json.active;
        this.licenseActive = json.licenseActive ? translate('app.yes') : translate('app.no');
        this.locked = json.locked;

        switch (true) {
            case this.roles.includes(UserView.ROLE_SUPERADMIN):
                this.role = translate('app.administration.user.filters.role.super_admin');
                break;
            case this.roles.includes(UserView.ROLE_ADMIN):
                this.role = translate('app.administration.user.filters.role.admin');
                break;
            case this.roles.includes(UserView.ROLE_MANAGER):
                this.role = translate('app.administration.user.filters.role.manager');
                break;
            case this.roles.includes(UserView.ROLE_ANALYST):
                this.role = translate('app.administration.user.filters.role.analyst');
                break;
            default:
                this.role = translate('app.administration.user.filters.role.user');
        }
    }
}
